export default __webpack_public_path__ + "static/media/court.88e5fb0f.jpg";